export default __webpack_public_path__ + "static/media/icon-lock.a4539849.svg";